import React, { useState, useEffect } from "react";
import Select from "react-select";
import CustomMenuList from "./CustomMenuList";
import { Translate } from "../../Enums/Tranlate";
import { useSelector } from "react-redux";

const ScrollPagination = ({
	Service,
	setData,
	value = "",
	isMulti = false,
	nameVal,
	placeholder = "select",
	filterParams = {},
	limit = 10,
}) => {
	const lang = useSelector((state) => state.auth.lang);
	const [options, setOptions] = useState([]);
	const [page, setPage] = useState(0);
	const [hasMore, setHasMore] = useState(true);
	const [inputValue, setInputValue] = useState("");

	const fetchOptions = async (reset = false) => {
		const currentPage = reset ? 1 : page;
		const pageSize = limit || filterParams?.limit || 10;

		try {
			let params = {
				page: currentPage,
				limit: pageSize,
				...filterParams,
			};
			if (!!inputValue) params["search"] = inputValue;

			const res = await Service.getList({ ...params });
			if (res?.status) {
				let response = res?.data?.data;
				let items =
					response?.data?.map((emp) => {
						return {
							...emp,
							label: emp[nameVal] || emp?.names?.[lang] || emp?.name,
							value: emp?.id,
						};
					}) || [];
				setOptions((prev) => (reset ? items : [...prev, ...items]));
				if (
					response?.meta?.totalPages !== undefined &&
					response?.meta?.totalPages !== null
				) {
					setHasMore(currentPage < response.meta.totalPages);
				} else if (response?.meta?.total !== undefined) {
					const totalPages = Math.ceil(response.meta.total / pageSize);
					setHasMore(currentPage < totalPages);
				} else {
					setHasMore(items.length >= pageSize);
				}
				if (items.length) setPage(currentPage + 1);
			}
		} catch (error) {
			console.error("Error loading: ", error);
		}
	};

	useEffect(() => {
		const timeout = setTimeout(() => {
			setPage(1);
			fetchOptions(true);
		}, 300);

		return () => clearTimeout(timeout);
	}, [inputValue]);

	return (
		<Select
			options={options}
			components={{ MenuList: CustomMenuList }}
			onScrollToBottom={async () => {
				if (hasMore) await fetchOptions();
			}}
			onInputChange={(value) => setInputValue(value)}
			inputValue={inputValue}
			value={value}
			isMulti={isMulti}
			placeholder={Translate[lang]?.[placeholder] || placeholder}
			isClearable
			onChange={(e) => setData(e)}
		/>
	);
};
export default ScrollPagination;
